import {dataType} from "../types/tag";

export const SPEC_TYPE_TEXT = { id: 1, name: 'Text' };
export const SPEC_TYPE_TAG = { id: 2, name: 'Tag' };
export const SPEC_TYPE_TAGS = { id: 3, name: 'Tags' };
export const SPEC_TYPE_DATE = { id: 4, name: 'Date' };
export const SPEC_TYPE_RICH_TEXT = { id: 5, name: 'Rich Text' };
export const SPEC_TYPE_CURRENCY = { id: 6, name: 'Currency' };
export const SPEC_TYPE_NUMBER = { id: 7, name: 'Number' };
export const SPEC_TYPE_RATING = { id: 8, name: 'Rating' };
export const SPEC_TYPE_IMAGES = { id: 9, name: 'Images' };
export const SPEC_TYPE_LIST_TAG = { id: 10, name: 'listTag' };

export const SPEC_NAME_PLAIN_TEXT_ENTRY = [
    'text',
    'currency',
    'number',
];

export const isSpecTypeNamePlainTextEntry = (name: string) => SPEC_NAME_PLAIN_TEXT_ENTRY.indexOf(name) >= 0;

export const SPEC_NAME_POPUP_EDIT = [
    'tag',
    'tags',
    'date',
    'rich text',
];

export const isSpecTypeNamePopupEdit = (name: string) => SPEC_NAME_POPUP_EDIT.indexOf(name) >= 0;

export const SPEC_TYPE_IDS_WITH_RESTRICTIONS = Array(
    SPEC_TYPE_TAG.id,
    SPEC_TYPE_TAGS.id,
);

export const isSpecTypeIdWithRestrictions = (id: number) => SPEC_TYPE_IDS_WITH_RESTRICTIONS.indexOf(id) >= 0;

export const SPEC_TYPE_IDS_NUMERIC = Array(
    SPEC_TYPE_CURRENCY.id,
    SPEC_TYPE_NUMBER.id,
    SPEC_TYPE_RATING.id,
);

export const isSpecTypeIdNumeric = (id: number) => SPEC_TYPE_IDS_NUMERIC.indexOf(id) >= 0;


export const SPEC_ID_PLAIN_TEXT_ENTRY = [
    SPEC_TYPE_TEXT.id,
    SPEC_TYPE_CURRENCY.id,
    SPEC_TYPE_NUMBER.id,
];
export const SPEC_ID_IMAGES_ENTRY = [
    SPEC_TYPE_IMAGES.id
];

export const isSpecTypeIdPlainTextEntry = (id: number) => SPEC_ID_PLAIN_TEXT_ENTRY.indexOf(id) >= 0;
export const isSpecTypeIdImagesEntry = (id: number) => SPEC_ID_IMAGES_ENTRY.indexOf(id) >= 0;

// listTag is only editable by owner brands at the network level
export const SPEC_TYPE_IDS_NOT_EDITABLE_BY_NON_OWNER = [
    SPEC_TYPE_LIST_TAG.id,
];

export const isSpecTypeIdNotEditableByNonOwner = (id: number) => SPEC_TYPE_IDS_NOT_EDITABLE_BY_NON_OWNER.indexOf(id) >= 0;
export const isSpecTypeIdListTag = (id: number) => id === SPEC_TYPE_LIST_TAG.id;
export const isSpecTypeNameListTag = (name: string) => name.toLowerCase() === SPEC_TYPE_LIST_TAG.name.toLowerCase();

export const SPEC_DATA_TYPES: dataType[] = [
    SPEC_TYPE_TEXT,
    SPEC_TYPE_TAG,
    SPEC_TYPE_TAGS,
    SPEC_TYPE_DATE,
    SPEC_TYPE_RICH_TEXT,
    SPEC_TYPE_CURRENCY,
    SPEC_TYPE_NUMBER,
    SPEC_TYPE_RATING,
    SPEC_TYPE_IMAGES,
    SPEC_TYPE_LIST_TAG,
];

// @see tagsEdit_template.ts for example usage.
export const SPEC_TYPE_MAP: Map<number, string> = new Map([
    [undefined, null],
    [null, null],
    [SPEC_TYPE_TEXT.id, SPEC_TYPE_TEXT.name],
    [SPEC_TYPE_TAG.id, SPEC_TYPE_TAG.name],
    [SPEC_TYPE_TAGS.id, SPEC_TYPE_TAGS.name],
    [SPEC_TYPE_DATE.id, SPEC_TYPE_DATE.name],
    [SPEC_TYPE_RICH_TEXT.id, SPEC_TYPE_RICH_TEXT.name],
    [SPEC_TYPE_CURRENCY.id, SPEC_TYPE_CURRENCY.name],
    [SPEC_TYPE_NUMBER.id, SPEC_TYPE_NUMBER.name],
    [SPEC_TYPE_RATING.id, SPEC_TYPE_RATING.name],
    [SPEC_TYPE_IMAGES.id, SPEC_TYPE_IMAGES.name],
    [SPEC_TYPE_LIST_TAG.id, SPEC_TYPE_LIST_TAG.name],
]);



// WEBPACK FOOTER //
// ./js/utils/consts/tag_spec_type.ts